// extracted by mini-css-extract-plugin
module.exports = {"container":"JobSeekerCardList_container__3Hfc_","item":"JobSeekerCardList_item__oSK6L","sending":"JobSeekerCardList_sending__9V65B"};